export default function Marquee({ items }) {
  const row = (hidden) => (
    <ul
      aria-hidden={hidden || undefined}
      className="flex w-max shrink-0 items-center gap-10 pr-10"
    >
      {items.map((label, i) => (
        <li
          key={i}
          className="flex items-center gap-10 whitespace-nowrap font-mono text-xs font-semibold uppercase tracking-[0.3em] text-slate-400"
        >
          {label}
          <span className="h-1.5 w-1.5 rounded-full bg-brand-orange" aria-hidden="true" />
        </li>
      ))}
    </ul>
  );

  return (
    <div
      data-testid="marquee-band"
      className="relative overflow-hidden border-y border-white/10 bg-brand-obsidian py-5"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
